export const onChangeCreateBorder = (dataChangeType: string, page: string, Data: any, title: string) => {
    return {
      type: 'onChangeCreateBorder',
      tkHeaderBorderData: Data,
      ChangeType: dataChangeType,
      pageNumber: page,
      title: title
    }
  }